import {createReducer} from '@reduxjs/toolkit'
import {Category} from '@wix/ambassador-wix-events-web/types'

export interface CategoriesState {
  categories: Category[]
}

const defaultState: CategoriesState = {
  categories: [],
}

export const categories = createReducer(defaultState, () => {})
